'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _objectPath = require('object-path');

var _objectPath2 = _interopRequireDefault(_objectPath);

var _shallowequal = require('shallowequal');

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _ExpandIcon = require('./ExpandIcon');

var _ExpandIcon2 = _interopRequireDefault(_ExpandIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TableCell = _react2["default"].createClass({
  displayName: 'TableCell',

  propTypes: {
    record: _react.PropTypes.object,
    prefixCls: _react.PropTypes.string,
    isColumnHaveExpandIcon: _react.PropTypes.bool,
    index: _react.PropTypes.number,
    expanded: _react.PropTypes.bool,
    expandable: _react.PropTypes.any,
    onExpand: _react.PropTypes.func,
    needIndentSpaced: _react.PropTypes.bool,
    indent: _react.PropTypes.number,
    indentSize: _react.PropTypes.number,
    column: _react.PropTypes.object
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
    return !(0, _shallowequal2["default"])(nextProps, this.props);
  },
  isInvalidRenderCellText: function isInvalidRenderCellText(text) {
    return text && !_react2["default"].isValidElement(text) && Object.prototype.toString.call(text) === '[object Object]';
  },
  render: function render() {
    var _props = this.props;
    var record = _props.record;
    var indentSize = _props.indentSize;
    var prefixCls = _props.prefixCls;
    var indent = _props.indent;
    var isColumnHaveExpandIcon = _props.isColumnHaveExpandIcon;
    var index = _props.index;
    var expandable = _props.expandable;
    var onExpand = _props.onExpand;
    var needIndentSpaced = _props.needIndentSpaced;
    var expanded = _props.expanded;
    var column = _props.column;
    var dataIndex = column.dataIndex;
    var render = column.render;
    var className = column.className;


    var text = _objectPath2["default"].get(record, dataIndex);
    var tdProps = void 0;
    var colSpan = void 0;
    var rowSpan = void 0;

    if (render) {
      text = render(text, record, index);
      if (this.isInvalidRenderCellText(text)) {
        tdProps = text.props || {};
        rowSpan = tdProps.rowSpan;
        colSpan = tdProps.colSpan;
        text = text.children;
      }
    }

    // Fix https://github.com/ant-design/ant-design/issues/1202
    if (this.isInvalidRenderCellText(text)) {
      text = null;
    }

    var expandIcon = _react2["default"].createElement(_ExpandIcon2["default"], {
      expandable: expandable,
      prefixCls: prefixCls,
      onExpand: onExpand,
      needIndentSpaced: needIndentSpaced,
      expanded: expanded,
      record: record
    });

    var indentText = _react2["default"].createElement('span', {
      style: { paddingLeft: indentSize * indent + 'px' },
      className: prefixCls + '-indent indent-level-' + indent
    });

    if (rowSpan === 0 || colSpan === 0) {
      return null;
    }
    return _react2["default"].createElement(
      'td',
      {
        colSpan: colSpan,
        rowSpan: rowSpan,
        className: className || ''
      },
      isColumnHaveExpandIcon ? indentText : null,
      isColumnHaveExpandIcon ? expandIcon : null,
      text
    );
  }
});

exports["default"] = TableCell;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/~/rc-table/lib/TableCell.js
// module id = 291
// module chunks = 0